module.exports = __webpack_public_path__ + "static/media/portoEduc_Bn_Porto_Educast_Home.44a22b7d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portoEduc_Bn_Porto_Educast_Home.jpg
// module id = 1377
// module chunks = 0